import getStore from '../index';
import { updateMomentumBonus, setMomentumBonuses, clearMomentumState, updateMomentumStatus } from '../actions/momentum';

export const receivedMomentumMessage = (message, data) => {
  if (window.config && window.config.momentumEnabled !== '1') return;
  const store = getStore();
  const prize = store?.getState().momentum?.prize?.value;

  switch (message) {
    case 'momentum_award_created': {
      store.dispatch(setMomentumBonuses(data, 'ws', 'momentum_award_created'));
      break;
    }
    case 'momentum_award_progress': {
      if (prize?.uuid === data.uuid) {
        store.dispatch(updateMomentumBonus({
          wager_progress: data.progress ?? 0,
          changes: (prize?.changes ?? 0) + 1,
        }));
      }
      break;
    }
    case 'momentum_award_status-DONT-HANDLE':
    case 'momentum_award_done-DONT-HANDLE': {
      if (prize?.uuid === data.uuid && data.status === 'wagered') {
        // wagered  ->  prize won
        store.dispatch(updateMomentumBonus({
          status: 'wagered',
        }));
      } else {
        // clear state for other statuses; this will hide prize component from game header
        store.dispatch(clearMomentumState(true));
      }
      break;
    }
    case 'momentum_award_completed': {
      let noInstantComplete = true;

      if (prize?.lucky_star_prize?.reward_type === 'INSTANT_COMPLETE') {
        // If the prize is an instant complete, we don't want to update the status to 'wagered'
        // because it will be handled by the lucky star award animation cycle.
        noInstantComplete = false;
      }

      // wagered  ->  prize won
      if (prize?.uuid === data.uuid && noInstantComplete) {
        store.dispatch(updateMomentumBonus({
          status: 'wagered',
        }));
      }
      break;
    }
    case 'momentum_award_expired': {
      // wagered  ->  prize won
      if (prize?.uuid === data.uuid) {
        store.dispatch(updateMomentumBonus({
          status: 'expired',
        }));
      }
      break;
    }
    case 'momentum_status': {
      store.dispatch(updateMomentumStatus(!data.is_up));
      break;
    }
    case 'momentum_award_canceled':
    case 'momentum_award_timeout': {
      if (prize?.uuid === data.uuid) {
        store.dispatch(clearMomentumState(true));
      }
      break;
    }
    case 'momentum_lucky_star_add': {
      if (prize?.uuid === data.uuid) {
        store.dispatch(updateMomentumBonus({
          lucky_star: data.lucky_star ?? null,
        }, null, 'ws'));
      }
      break;
    }
    case 'momentum_lucky_star_award': {
      if (prize?.uuid === data.uuid) {
        store.dispatch(updateMomentumBonus({
          lucky_star_prize: data.lucky_star_prize ?? null,
          lucky_star: data.lucky_star ?? null,
        }, null, 'ws'));
      }
      break;
    }
    default: {
      console.error(`receivedMomentumMessage: unknown message: ${message}`);
    }
  }

};

export default receivedMomentumMessage;